import { WatchQueryFetchPolicy } from 'apollo-client';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

export const useCrmDuplicateCheck = (params: DuplicateCheckParams, fetchPolicy?: WatchQueryFetchPolicy) => {
  const { data, error, loading } = useQuery<DuplicateCheckData, DuplicateCheckParams>(CrmDuplicateCheckQuery, {
      fetchPolicy,
      variables: {
        email: params.email,
        isIncludeParty: params.isIncludeParty,
        isIncludeEnquiry: params.isIncludeEnquiry,
        name: params.name,
      }
  });

  return {
      data,
      error,
      loading,
  };
};

export type DuplicateCheckParams = {
   email: string | null;
   isIncludeParty?: boolean | null
   isIncludeEnquiry: boolean | null
   name?: string | null
};

export type DuplicateCheckData = {
    crm: CRM;
};

export type CRM = {
    duplicateCheck: DuplicateCheck;
};

export type DuplicateCheck = {
    contactName:                  string;
    contactEmailAddress:          string;
    enquiryName:                  string;
    enquiryEmailAddress:          string;
    otherSideName:                string;
    otherSideEmailAddress:        string;
    partyDuplicateCount:          number;
    enquiryContactDuplicateCount: number;
    mobile:                      string;
    phone:                      string;
    contactMatterList:            ContactMatterList[];
    contactMatterListByName:     ContactMatterList[];
    contactEnquiries:             ContactEnquiry[];
    contactEnquiriesByName:       ContactEnquiry[];
    contactEnquriesOtherSide:    ContactEnquiry[];
    contactEnquriesOtherSideByName: ContactEnquiry[];
};

export interface ContactEnquiry {
    enquiryGuid: string;
    enquiryName: string;
    areaOfLaw: string;
    enquiryDate: string;
    assignedToGuid: string;
    assignedToName: string;
}

export interface ContactMatterList {
    nameId:         string;
    nameGuid:       string;
    name:           string;
    phone:          string;
    mobile:        string;
    gender:        string;
    title:         string;
    firstName:      string;
    lastname:       string;
    organisationGuid: string;
    organisationName: string;
    isFromDataSource: boolean;
    contactMatters: ContactMatter[];
}

export interface ContactMatter {
    id:         number;
    fileNumber: string;
    type:       string;
    roles:      string;
    status:     string;
}

export const CrmDuplicateCheckQuery = gql`
    query CrmDuplicateCheck(
        $email: String
        $isIncludeParty: Boolean
        $isIncludeEnquiry: Boolean
        $name: String
    ) {
        crm {
            duplicateCheck(
                email: $email
                isIncludeParty: $isIncludeParty
                isIncludeEnquiry: $isIncludeEnquiry
                name: $name
            ) {
                contactName
                contactEmailAddress
                enquiryName
                enquiryEmailAddress
                otherSideName
                otherSideEmailAddress
                partyDuplicateCount
                enquiryContactDuplicateCount
                mobile
                phone
                contactMatterList {
                    nameId
                    nameGuid
                    name
                    phone
                    mobile
                    gender
                    title
                    firstName
                    lastname
                    organisationGuid
                    organisationName
                    isFromDataSource
                    contactMatters {
                        id
                        fileNumber
                        type
                        roles
                        status
                    }
              	}
                contactMatterListByName {
                    nameId
                    nameGuid
                    name
                    phone
                    mobile
                    gender
                    title
                    firstName
                    lastname
                    organisationGuid
                    organisationName
                    isFromDataSource
                    contactMatters {
                        id
                        fileNumber
                        type
                        roles
                        status
                    }
                }
                contactEnquiries {
                    enquiryGuid
                    enquiryName
                    areaOfLaw
                    enquiryDate
                    assignedToGuid
                    assignedToName
                }
                contactEnquiriesByName {
                    enquiryGuid
                    enquiryName
                    areaOfLaw
                    enquiryDate
                    assignedToGuid
                    assignedToName
                }
                contactEnquriesOtherSide {
                    enquiryGuid
                    enquiryName
                    areaOfLaw
                    enquiryDate
                    assignedToGuid
                    assignedToName
                }
                contactEnquriesOtherSideByName {
                    enquiryGuid
                    enquiryName
                    areaOfLaw
                    enquiryDate
                    assignedToGuid
                    assignedToName
                }
            }
        }
    }
`;